import React from 'react';
import './App.css';

import AppRouter from './ui/AppRouter';
import { ThemeProvider } from './ui/providers/ThemeProvider';

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <AppRouter />
    </ThemeProvider>
  );
};

export default App;
